<div
    ngbDropdown
    #dropdown="ngbDropdown"
    class="d-inline-block w-100 h-100"
    [placement]="position"
    [autoClose]="multiSelect && menuItems.length > 1 ? 'outside' : true"
>
    <button
        ngbDropdownToggle
        id="dropdownButtonMenu"
        type="button"
        [ngClass]="[
            dropdownClass,
            dropdown.isOpen() ? 'focus' : '',
            position.split('-')[0],
        ]"
        [disabled]="disabled || menuItems.length === 0"
        (click)="$event.stopPropagation(); $event.preventDefault()"
    >
        <div class="pe-1">{{ label }}</div>
    </button>
    <div
        ngbDropdownMenu
        aria-labelledby="dropdownButtonMenu"
        [style.max-height]="maxHeight"
        class="mt-1"
    >
        @for (item of menuItems; track item.value) {
            @if (item.subMenu && item.subMenu.menu.length > 0) {
                <div
                    ngbDropdown
                    #subMenudropdown="ngbDropdown"
                    class="d-inline-block w-100 h-100"
                    container="body"
                    [placement]="item.subMenu.position || position"
                    [autoClose]="
                        multiSelect && menuItems.length > 1 ? 'outside' : true
                    "
                >
                    <button
                        ngbDropdownToggle
                        id="dropdownButtonMenu"
                        type="button"
                        [ngClass]="[
                            dropdownClass,
                            'dropdown-subitem',
                            (item.subMenu.position || position).split('-')[0],
                        ]"
                        (click)="
                            $event.stopPropagation(); $event.preventDefault()
                        "
                    >
                        <div class="pe-1">{{ item.label }}</div>
                    </button>
                    <div
                        ngbDropdownMenu
                        aria-labelledby="dropdownButtonMenu"
                        [style.max-height]="maxHeight"
                        class="mt-1"
                    >
                        @for (item of item.subMenu.menu; track item.value) {
                            <button
                                ngbDropdownItem
                                [tabindex]="$index"
                                [ngClass]="dropdownItemClass(item)"
                                (click)="toggleSelection($event, item.value)"
                                (keypress)="handleKeyPress($event, item.value)"
                                [disabled]="item.disabled"
                                type="button"
                            >
                                {{ item.label }}
                            </button>
                        }
                    </div>
                </div>
            } @else {
                <button
                    ngbDropdownItem
                    [tabindex]="$index"
                    [ngClass]="dropdownItemClass(item)"
                    (click)="toggleSelection($event, item.value)"
                    (keypress)="handleKeyPress($event, item.value)"
                    [disabled]="item.disabled"
                    type="button"
                >
                    {{ item.label }}
                </button>
            }
        }
    </div>
</div>
